import { Component, computed, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ApiAuthService } from '../../../services/backend/public/api-auth/api-auth.service';

@Component({
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  imports: [RouterLink]
})
export class DashboardComponent {
  private readonly auth = inject(ApiAuthService);
  private readonly router = inject(Router);
  readonly identity = this.auth.identity;
  readonly access = computed(() => this.auth.identity()?.dashboard);
  readonly canCreate = computed(() => this.access()?.canCreateProject === true);
  readonly canConsult = computed(() => this.access()?.canConsultProjects === true);
  readonly hasActions = computed(() => this.canCreate() || this.canConsult());

  logout(): void {
    this.auth.logout().subscribe({ error: () => { void this.router.navigateByUrl('/inicio-sesion'); } });
  }
}
